import { defineStore } from "pinia";
import i18n from "@/i18n";
import {  getCountryListApi } from "@/api/mediaManagement";

/**
 * selectdChannel: 直播频道下选择的频道列表
 * categoryType: 直播分类类型
 * transferProtocol:传输协议的字典，，用于下拉菜单
 * videoEncryption: 视频解密的字典，用于下拉菜单
 * distributionStrategyOptions: 分发策略下拉项（国家数据 + default/vpn_ip/block_ip 三条固定数据）
 */
type CommonType = {
  selectdChannel: object[],
  categoryType: object[],
  transferProtocol: object[],
  videoEncryption: object[],
  distributionStrategyOptions: object[]
}

export const liveStore = defineStore('liveStore', {
  state: ():CommonType => {
    return {
      selectdChannel: [],
      categoryType: [],
      transferProtocol: [],
      videoEncryption: [],
      distributionStrategyOptions: []
    }
  },
  actions: {
    addSelectedChannel(data:object[]) {
      this.selectdChannel = data
    },
    clearSelectedChannel() {
      this.selectdChannel = []
    },
    addCategoryType (data:object[]) {
      this.categoryType = data
    },
    clearCategoryType () {
      this.categoryType = []
    },
    addTransferProtocol (data:object[]) {
      this.transferProtocol = data
    },
    addVideoEncryption (data:object[]) {
      this.videoEncryption = data
    },
    /**
     * 获取分发策略下拉项：国家数据 + default/vpn_ip/block_ip 三条固定数据
     * 带缓存：已拉取过则直接复用，避免多个组件重复请求
     * @param force 传 true 可强制重新拉取
     */
    async getDistributionStrategyOptions (force = false) {
      if (!force && this.distributionStrategyOptions.length > 0) {
        return this.distributionStrategyOptions
      }
      const t = i18n.global.t
      // 固定的三条策略
      const fixedOptions = [
        { label: t('不限_default'), value: 'default' },
        { label: t('VPN访问'), value: 'vpn_ip' },
        // { label: t('黑名单访问'), value: 'block_ip' }
      ]
      try {
        const { code, data } = await getCountryListApi() as any
        if (code === '0' || code === 0) {
          const countryOptions = (data || []).map((item:any) => ({
            label: item.name,
            value: item.code
          }))
          this.distributionStrategyOptions = [...fixedOptions, ...countryOptions]
        } else {
          this.distributionStrategyOptions = [...fixedOptions]
        }
      } catch (e) {
        this.distributionStrategyOptions = [...fixedOptions]
      }
      return this.distributionStrategyOptions
    }

  }
})